import React from 'react';
import { Grid, IconButton, Stack, Dialog, Typography } from '@mui/material';
import { CustomDialogContent, CustomDialogTitle, FlexDiv, StyledCard, StyledCardTitle } from '../../../../../custom/components';
import { CloseIconBtn, DocIcon, DownloadIcon } from 'custom/constants';
import reportStyles  from './reports.module.css';
import ZoomIn from '../../../../../assets/images/actionIcons/zoomIn.svg';
import ZoomOut from '../../../../../assets/images/actionIcons/zoomOut.svg';
import PDFSlider from '../../../common/PDFSlider';
import environment from 'custom/environments';

const DocViewer = (props) => {
  const { item } = props;

  return (
    <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'attached_docs'} onClose={props.closeModal} maxWidth={'md'} fullWidth>
      <CustomDialogTitle id='form-dialog-title'>  Attached Documents
        <CloseIconBtn onClick={() => props.onClose()} />
      </CustomDialogTitle>
      <CustomDialogContent>
        <Grid container spacing={3}>
          <Grid item container xs={12}>
            <Grid item xs={12}>
              <StyledCard>
                <FlexDiv><StyledCardTitle>Document Viewer</StyledCardTitle></FlexDiv>
                <Stack direction='row' spacing={1} justifyContent='flex-end' mb={2} mt={'-30px'} alignItems={'center'}>
                  <Typography variant='body2' color={'primary'}>{props.scale != 1 ? (Math.round(props.scale * 100) + '%') : ''}</Typography>
                  <IconButton title='Zoom In' onClick={props.zoomIn} className={`${reportStyles.docIcon}`}>
                    <img src={ZoomIn} alt='zoom in' />
                  </IconButton>
                  <IconButton title='Zoom Out' onClick={props.zoomOut} className={`${reportStyles.docIcon}`}>
                    <img src={ZoomOut} alt='zoom out' />
                  </IconButton>
                  <IconButton className={`${reportStyles.docIcon}`} onClick={() => { window.open(`${environment.apiService}document?key=${item.src}&name=${item.name}`, '_blank');}}>
                    <DownloadIcon />
                  </IconButton>
                  <IconButton className={`${reportStyles.docIcon}`} onClick={() => { window.open(`${environment.apiService}document?key=${item.src}&name=${item.name}`, '_blank');}}>
                    <DocIcon />
                  </IconButton>
                </Stack>
                <PDFSlider file={`${environment.apiService}document?key=${item.src}&name=${item.name}` } scale={props.scale} />
              </StyledCard>
            </Grid>
          </Grid>
        </Grid>
      </CustomDialogContent>
    </Dialog>
  );
};

export default DocViewer;